var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.4019 4.5C43.5566 2.5 46.4434 2.5 47.5981 4.5L81.3731 63C82.5278 65 81.0844 67.5 78.775 67.5H11.225C8.9156 67.5 7.47223 65 8.62693 63L42.4019 4.5Z",
    fill: "#FFCE20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46 58.7503C48.3012 58.7503 50.1667 56.8848 50.1667 54.5837C50.1667 52.2825 48.3012 50.417 46 50.417C43.6988 50.417 41.8333 52.2825 41.8333 54.5837C41.8333 56.8848 43.6988 58.7503 46 58.7503Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8333 21.25H50.1667V46.25H41.8333V21.25Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warningIcon.c72d74b4b06acefef3cb41a12bee520c.svg";
export { ForwardRef as ReactComponent };